import React from 'react';
import { Container, Row } from 'react-bootstrap';

const SkeletonLoader = ({ rowCount = 3 }) => {
  const styles = {
    skeletonRow: {
      backgroundColor: '#f0f0f0',
      marginBottom: '10px',
      padding: '12px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
  };

  return (
    <Container fluid className="mt-4">
      {Array.from({ length: rowCount }, (_, index) => (
        <Row key={index} style={styles.skeletonRow} />
      ))}
    </Container>
  );
};

export default SkeletonLoader;
